import React, { useEffect } from "react";
import '../App.css'
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../components/language/en/translation_en.json";
import translationID from "../components/language/id/translation_id.json";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
const ModalGame = ({
  show,
  winner,
  score,
  onReset,
  onClose,
  player1Name,
  player2Name,
  Englishscore0,
  Englishscore1,
  player1Score,
  player2Score,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (show) {
      updateGameHistory();
    }
  }, [show]);
  if (!show) return null;

  const updateGameHistory = () => {
    const currentDateTime = new Date();
    const formattedDateTime = `${currentDateTime
      .getDate()
      .toString()
      .padStart(2, "0")}/${(currentDateTime.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${currentDateTime.getFullYear()} ${currentDateTime
          .getHours()
          .toString()
          .padStart(2, "0")}:${currentDateTime
            .getMinutes()
            .toString()
            .padStart(2, "0")}`;
    const newHistory = {
      date: formattedDateTime,
      status: "finish",
      user: [
        {
          nama: player1Name,
          gamescore: player1Score,
          englishscore: Englishscore0,
        },
        {
          nama: player2Name,
          gamescore: player2Score,
          englishscore: Englishscore1,
        },
      ],
    };

    try {
      if (typeof localStorage !== "undefined") {
        const existingHistory =
          JSON.parse(localStorage.getItem("gameDakonHistory")) || [];
        const updatedHistory = [...existingHistory, newHistory];
        localStorage.setItem("gameDakonHistory", JSON.stringify(updatedHistory));
      } else {
        console.warn("Local storage is not supported on this browser.");
      }
    } catch (error) {
      console.error("Error accessing local storage:", error);
    }
  };

  return (
    <div className="modal-overlay-game flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50">
      <div className="modal-content-game bg-white rounded-2xl shadow-lg w-72 py-10 px-5 text-center relative ">
        <div className="modal-body-game my-10">
          <h3 className="winner-title-game text-4xl font-bold m-0">Winner</h3>
          <p className="winner-name-game text-2xl font-bold rounded-full py-2 my-2">
            {winner}
          </p>
          <h3 className="score-title-game text-2xl font-bold m-0">
            {t("game_score")}
          </h3>
          <p className="score-game text-3xl font-bold my-2">{score}</p>
        </div>

        <div className="modal-footer-game mt-5">
          <button
            className="new-game-button block text-white w-full font-bold py-2 px-4 rounded-full shadow-lg transition-all duration-200 ease-in-out"
            onClick={onReset}
          >
            {t("play_again")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalGame;
